<div *ngIf="message?.length" class="alert alert-{{ type }} alert-dismissible fade show {{ customClass }}" role="alert">
    <div class="d-flex align-items-center">
        <div class="{{icon}} icon"></div>
        {{ message }}
    </div>
    <button *ngIf="closeButton" type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="onRemove($event)"></button>
    <ng-content></ng-content>
</div>
